// extracted by mini-css-extract-plugin
export default {"banner1":"index_banner1_ZWWwF","bref":"index_bref_KxQSS","banner2":"index_banner2_VumZ7"};